import React from "react";
import { Col, Row } from "design-react-kit";
import { ValidatedForm, FormEnabler, MLabel, MFile, MInput, MRadioButton } from "components/forms";
import { COMPANY } from "const";
import { dateHelper } from "libs";

class TirocinioDirettoStep2 extends ValidatedForm {
  emptyFields = {
    isSchoolAccredited: "",
    schoolCode: "",
    schoolName: "",
    schoolAddress: "",
    schoolCap: "",
    schoolCity: "",
    schoolProvince: "",
    schoolEmail: "",
    schoolPec: "",
    dateEnd: "",
    document: 0,
  };

  state = {
    ...this.emptyFields,
    defaultValues: { ...this.emptyFields },
  };

  FIELDS_GROUP = [
    [
      {
        field: "progettoFormativo",
        label: "Progetto formativo",
        component: MLabel,
        className: "col-md-6 mb-0",
      },
      {
        id: "progettoFormativoFile",
        field: "document",
        label: "Progetto formativo",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "progettoFormativo",
          mandatory: true,
        },
        className: "col-md-12",
      },
    ],
    [
      {
        field: "convenzione",
        label: "Convenzione",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
      {
        id: "convenzioneFile",
        field: "document",
        label: "Convenzione",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "convenzione",
          mandatory: true,
        },
        className: "col-md-12",
      },
    ],
    [
      {
        id: "isSchoolAccredited",
        field: "isSchoolAccredited",
        label: <h6>Accreditamento scuola</h6>,
        payload: {
          options: [
            {
              value: "1",
              label:
                "Istituzione scolastica accreditata, nel rispetto di quanto previsto dalla normativa vigente, ai fini dello svolgimento delle attività̀ di tirocinio per i percorsi di formazione iniziale dei docenti delle scuole secondarie di primo e secondo grado ai sensi del D.P.C.M. 04 agosto 2023 per la classe di concorso di cui all'ammissione.",
            },
            { value: "2", label: "Istituzione scolastica presso la quale il tirocinante svolge attività di insegnamento." },
          ],
        },
        infoText: "Selezionare una delle due opzioni",
        component: MRadioButton,
        className: "col-md-12",
      },
    ],
    [
      {
        field: "schoolInfo",
        label: "Informazioni istituto",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
    ],
    [
      {
        id: "schoolCode",
        field: "schoolCode",
        label: "Codice meccanografico",
        component: MInput,
        type: "text",
        className: "col-md-6 mt-3",
      },
      {
        id: "schoolName",
        field: "schoolName",
        label: "Denominazione",
        component: MInput,
        type: "text",
        className: "col-md-6 mt-3",
      },
      {
        id: "schoolAddress",
        field: "schoolAddress",
        label: "Indirizzo",
        component: MInput,
        className: "col-md-10",
      },
      {
        id: "schoolCap",
        field: "schoolCap",
        label: "CAP",
        component: MInput,
        className: "col-md-2",
      },
      {
        id: "schoolCity",
        field: "schoolCity",
        label: "Comune",
        component: MInput,
        className: "col-md-10",
      },
      {
        id: "schoolProvince",
        field: "schoolProvince",
        label: "Provincia (sigla)",
        component: MInput,
        className: "col-md-2",
      },
      {
        id: "schoolEmail",
        field: "schoolEmail",
        label: "Indirizzo email",
        component: MInput,
        className: "col-md-6",
      },
      {
        id: "schoolPec",
        field: "schoolPec",
        label: "Indirizzo PEC",
        component: MInput,
        className: "col-md-6",
      },
    ],
  ];

  ERROR_MESSAGES = {
    isSchoolAccredited: "Selezionare una delle due opzioni",
    schoolCode: "Inserire un codice meccanografico valido",
    dateEnd: `La data deve essere precedente o uguale al ${dateHelper.toITDate(this.props.dateEnd)}`,
    schoolName: "Dato obbligatorio",
    schoolAddress: "Dato obbligatorio",
    schoolCap: "Dato obbligatorio",
    schoolCity: "Dato obbligatorio",
    schoolProvince: "Dato obbligatorio",
    schoolEmail: "Dato obbligatorio",
  };

  validation = {
    isSchoolAccredited: (value) => {
      return value !== "" && value !== undefined && value !== null;
    },
    schoolCode: (value) => value !== "" && value !== undefined && value.length === 10,
    schoolName: (value) => value !== "",
    schoolAddress: (value) => value !== "",
    schoolCap: (value) => value !== "",
    schoolCity: (value) => value !== "",
    schoolProvince: (value) => value !== "" && value.length < 4,
    schoolEmail: (value) => value !== "",
    dateEnd: (value) => {
      if (this.props.company !== COMPANY.UNICAMILLUS) return true;

      if (!value) return false;
      const selectedDate = new Date(value);

      const maxDate = new Date(this.props.dateEnd);

      return selectedDate <= maxDate;
    },
  };

  getFields = () => {
    const { isSchoolAccredited } = this.state;
    const { company } = this.props;

    const selectedOption = isSchoolAccredited?.value || isSchoolAccredited;

    let fields = [...this.FIELDS_GROUP];

    if (company === COMPANY.UNICAMILLUS) {
      const dateEndField = [
        {
          id: "dateEnd",
          field: "dateEnd",
          label: "Data fine tirocinio",
          component: MInput,
          type: "date",
          className: "col-md-4 mt-2",
        },
      ];

      fields.unshift(dateEndField);
    }

    if (selectedOption === "2") {
      const contrattoFields = [
        {
          field: "contrattoLavoro",
          label: "Contratto di lavoro",
          component: MLabel,
          className: "col-md-6 pt-3 pb-0 mb-0",
        },
        {
          id: "contrattoLavoroFile",
          field: "document",
          label: "Contratto di lavoro",
          component: MFile,
          config: {
            endPoint: "lesson-activity-file",
            fieldName: "document",
            maxFiles: 1,
            minFiles: 1,
            accept: ".pdf,.doc,.docx,.p7m",
            code: "contrattoLavoro",
            mandatory: true,
          },
          className: "col-md-12",
        },
      ];

      const radioIndex = fields.findIndex((group) => group.some((f) => f.id === "isSchoolAccredited"));
      fields.splice(radioIndex + 1, 0, contrattoFields);
    }

    return fields;
  };

  componentDidMount() {
    const { defaultValues } = this.props;

    if (defaultValues) {
      this.setState((prevState) => ({
        ...defaultValues,
        defaultValues: {
          ...prevState.defaultValues,
          ...defaultValues,
        },
      }));
    }
  }

  onSubmit = (e) => {
    if (e) e.preventDefault();

    const currentFields = this.getFields().flat();
    const currentIds = currentFields.map((f) => f.id || f.field);

    this.innerValidatedForms = this.innerValidatedForms.filter((component) => currentIds.includes(component.props.id));

    if (!this.checkValidation()) return;

    const questions = currentFields
      .filter((f) => f.id && this.state[f.id] !== undefined)
      .map((f) => {
        const answer = this.state[f.id]?.value !== undefined ? this.state[f.id].value : this.state[f.id];
        return {
          field: f.field,
          question: f.id === "isSchoolAccredited" ? "Accreditamento scuola" : f.label,
          answer: answer,
          type: "text",
        };
      });

    this.props.onSubmit(questions);
  };

  render() {
    const { tirocinioDiretto, formActive, onToggleEdit } = this.props;
    const { defaultValues, isSchoolAccredited } = this.state;

    const fields = this.getFields();

    const { formValid, code } = this.renderFields(fields, defaultValues, formActive);

    const radioSelected = isSchoolAccredited !== "" && isSchoolAccredited !== null;
    const enableSave = (formValid && radioSelected) || tirocinioDiretto.status === "approvePending";

    return (
      <>
        <Row>
          <Col className="col-12 mt-3">
            <form className="mt-3">{code}</form>
            <FormEnabler isFormActive={formActive} disableSave={!enableSave} onSubmit={this.onSubmit} onCancel={onToggleEdit} />
          </Col>
        </Row>
      </>
    );
  }
}

export default TirocinioDirettoStep2;
